"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScript = getScript;
exports.getScriptSource = getScriptSource;
exports.getScripts = getScripts;
var each_1 = __importDefault(require("licia/each"));
var strHash_1 = __importDefault(require("licia/strHash"));
var toStr_1 = __importDefault(require("licia/toStr"));
var util_1 = require("./util");
var resources = __importStar(require("./resources"));
var scripts = new Map();
scripts.set('1', {
    scriptId: '1',
    startColumn: 0,
    startLine: 0,
    endColumn: 100000,
    endLine: 100000,
    scriptLanguage: 'JavaScript',
    url: '',
});
var sources = new Map();
sources.set('1', '');
function getScript(scriptId) {
    return scripts.get(scriptId);
}
function getScriptSource(scriptId_1) {
    return __awaiter(this, arguments, void 0, function (scriptId, proxy) {
        var script, source;
        if (proxy === void 0) { proxy = ''; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (sources.get(scriptId)) {
                        return [2, sources.get(scriptId)];
                    }
                    script = getScript(scriptId);
                    return [4, (0, util_1.getTextContent)(script.url, proxy)];
                case 1:
                    source = _a.sent();
                    sources.set(scriptId, source);
                    return [2, sources.get(scriptId)];
            }
        });
    });
}
function getScripts() {
    var ret = [];
    var srcs = resources.getScripts();
    (0, each_1.default)(srcs, function (src) {
        var url = (0, util_1.getAbsoluteUrl)(src);
        var scriptId = getScriptId(url);
        if (!scripts.get(scriptId)) {
            scripts.set(scriptId, {
                scriptId: scriptId,
                startColumn: 0,
                startLine: 0,
                endColumn: 100000,
                endLine: 100000,
                scriptLanguage: 'JavaScript',
                url: url,
            });
        }
        ret.push(scripts.get(scriptId));
    });
    return ret;
}
function getScriptId(url) {
    return (0, toStr_1.default)((0, strHash_1.default)(url));
}
